import { lazy, Suspense } from 'react';

const Discussion = lazy(() => import('./Discussion'));

export default function DiscussionLazy(props) {
  return (
    <Suspense fallback={null}>
      <Discussion {...props} />
    </Suspense>
  );
}